<template>
    <div>
        <div class="full-length-block">
            <div class="content-code">
                <div class="bottomRight-request">
                <p>{{$t('ExampleRequest')}}</p>
                <p>{{$t('symbols')}}</p>
                </div>
                <div class="preload-bg">
                <div class="preloadURL">
                <p>{{$t('curlGET')}} <span ref="url_link_add">'http://server-address:port/api/v2/market/symbols?token=YoC1Buiy'</span></p>
                </div>
                <a href="#" @click.prevent="$parent.handleCopy($refs.url_link_add)" class="copyURL"><feather type="copy"></feather> </a>
                </div>
            </div>
            <div class="content">
                <div class="overflow-hidden content-section" id="content-get-started">
                    <div class="api-information">
                        <div class="folder-name"><p class="headTitle">{{$t('market')}}</p></div>
                        <div class="folder-description"></div>
                    </div>
                    <div class="api-information">
                        <div class="heading">
                        <div class="name addIcon">
                            <span class="GET method green" title="GET">{{$t('GET')}}</span>
                            {{$t('symbols')}} <feather type="lock"></feather>
                            <span class="lock-icon"></span>
                        </div>
                        </div>
                        <div class="url">http://server-address:port/api/v2/market/symbols?token=YoC1Buiy</div>
                        <div class="description request-description">
                        <p>{{$t('symbolsMsz')}}</p>
                        <p>{{$t('responce')}}</p>
                        <div class="desc_code">
                            <pre class="click-to-expand-wrapper is-snippet-wrapper  language-undefined" :class="(read_more)?'is-expandable':''">
                                <code class=" is-highlighted language-undefined">{
    "success": true,
    "message": "",
    "result": [
        {
            "Symbol": "EURUSD",
            "MarketCurrency": "EUR",
            "BaseCurrency": "USD",
            "Description": "",
            "Active": "Y",
            "MinTradeSize": 100,
            "Precision": 0.00001,
            "ContractSize": 10000,
            "Buy": 1.10778,
            "Sell": 1.10775,
            "PriceDate": "2019-10-16T13:18:33.878000000"
        }
    ]
}
                                </code>
                            </pre>
                            <div class="expandMore">
                                <a class="showMore-btn" v-if="!read_more" href="#" @click.prevent="read_more = true">{{$t('ReadMore')}}</a>  
                                <a class="showLess-btn" v-if="read_more" href="#" @click.prevent="read_more = false">{{$t('ReadLess')}}</a>  
                            </div>
                        </div>
                        </div>
                        <!-- <div class="authorization-info" id="auth-info-">
                        <div class="heading"> AUTHORIZATION <span class="auth-type"> Digest Auth </span> </div>
                        </div>  -->
                        <div class="query-params">
                        <div class="heading">{{$t('PARAMS')}}</div>
                            <hr>
                            <div class="param row justify-content-end">
                            <div class="name col-md-3 col-xs-12">{{$t('token')}}</div>
                            <div class="value col-md-9 col-xs-12">YoC1Buiy</div>
                                <div class="description col-md-9 col-xs-12">
                                <p></p>
                                </div>
                            </div>
                        </div>  
                    </div> 
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'market',
    data(){
        return {
            read_more: false,
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/fxView/tradingtools/api_document/market.vue